import {Component, EventEmitter, OnInit} from '@angular/core';
import {UtilsService} from "../../../services/utils.service";
import {SelfAssessmentService} from "../self-assessment.service";
import {Overlayable} from "../../../interfaces/overlayable";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-self-assessment-header',
  templateUrl: './self-assessment-header.component.html',
  styleUrls: ['./self-assessment-header.component.scss']
})
export class SelfAssessmentHeaderComponent implements OnInit, Overlayable {
  onClosed = new EventEmitter<boolean>();
  totalPages = '05';
  currentPage = '01'
  currentPageNumber = 1;

  pageTitles = new Array(0);
  titleHint = "Mein Beruf / meine Ausbildung soll folgende Anforderungen haben.";

  constructor(private utils: UtilsService, private selfAssessment: SelfAssessmentService) {
  }

  ngOnInit() {
    this.selfAssessment.onCurrentPageNumberChanged().pipe(untilDestroyed(this)).subscribe((val) => {
      this.currentPageNumber = val;
      this.currentPage = this.utils.getNumberWithLeadingZero(val);
    });

    this.totalPages = this.utils.getNumberWithLeadingZero(this.selfAssessment.totalPageNumber);

    this.selfAssessment.getRequirementsList().pipe(untilDestroyed(this)).subscribe((val) => {
      this.pageTitles = [];
      val.forEach((el) => {
        this.pageTitles = [...this.pageTitles, el.name];
      })
    })
  }


}
